import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

export const Navigation: React.FC = () => {
  const location = useLocation();
  const isMarketingActive = location.pathname.startsWith('/admin/marketing');

  return (
    <nav className="main-navigation">
      <div className="nav-container">
        <Link 
          to="/admin" 
          className={`nav-link ${location.pathname === '/admin' ? 'active' : ''}`}
        >
          Events Dashboard
        </Link>
        <Link 
          to="/admin/scrapers" 
          className={`nav-link ${location.pathname === '/admin/scrapers' ? 'active' : ''}`}
        >
          Scrapers Dashboard
        </Link>
        <Link 
          to="/admin/hosts" 
          className={`nav-link ${location.pathname === '/admin/hosts' ? 'active' : ''}`}
        >
          Hosts Dashboard
        </Link>
        <Link 
          to="/admin/missions" 
          className={`nav-link ${location.pathname === '/admin/missions' ? 'active' : ''}`}
        >
          Missions Dashboard
        </Link>
        <Link 
          to="/admin/marketing" 
          className={`nav-link ${isMarketingActive ? 'active' : ''}`}
        >
          Marketing Cockpit
        </Link>
      </div>
    </nav>
  );
};
